import React, { useState } from 'react';
import { Container, Row, Col } from "reactstrap";
import InputMask from 'react-input-mask';
import * as toastr from "toastr";
import moment from "moment";

import Loader from "Placements/Components/Loader";
import API from 'Placements/API';

import './style.scss';
import * as iconBack from 'Placements/Assets/img/icon/arrow-back-purple.png';


type RegisterUserProps = {
    onUpdateUserData: Function
}

const Formulario = ({ onUpdateUserData }: RegisterUserProps) => {

    const [isLoading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [phone, setPhone] = useState("");
    const [city, setCity] = useState("");
    const [birthday, setBirthday] = useState("");
    const [company, setCompany] = useState("");
    const [school, setSchool] = useState("");
    const [receiveMail, setReceiveMail] = useState(false);

    const handleInput = (e: any) => {

        if (e.target.value == "") {

            document.getElementById(e.target.id).style.borderColor = "red";

        } else {

            document.getElementById(e.target.id).style.borderColor = "#66279b";

            switch (e.target.name) {
                case "name": setName(e.target.value); break;
                case "email": setEmail(e.target.value); break;
                case "password": setPassword(e.target.value); break;
                case "confirm_password": setConfirmPass(e.target.value); break;
                case "phone": setPhone(e.target.value.replace(")", "").replace("(", "").replace("-", "")); break;
                case "city": setCity(e.target.value); break;
                case "birthday": setBirthday(e.target.value); break;
                case "company": setCompany(e.target.value); break;
                case "school": setSchool(e.target.value); break;
            }

        }

    }

    const handleRegister = async (e: any) => {

        e.preventDefault();
        setLoading(true);

        try {

            if (name === "" || email === "" || password === "" || phone === "" || city === "" || birthday === "") {

                toastr.error("Preencha todos os dados não opcionais");

                document.getElementById("name").style.borderColor = name === "" ? "red" : "#66279b";
                document.getElementById("email").style.borderColor = email === "" ? "red" : "#66279b";
                document.getElementById("password").style.borderColor = password === "" ? "red" : "#66279b";
                document.getElementById("confirm_password").style.borderColor = confirmPass === "" ? "red" : "#66279b";
                document.getElementById("phone").style.borderColor = phone === "" ? "red" : "#66279b";
                document.getElementById("city").style.borderColor = city === "" ? "red" : "#66279b";
                document.getElementById("birthday").style.borderColor = birthday === "" ? "red" : "#66279b";

            } else {

                if (password !== confirmPass) {

                    document.getElementById("password").style.borderColor = "red";
                    document.getElementById("confirm_password").style.borderColor = "red";

                    toastr.error("Campos de senha estão divergindo");

                } else {

                    const re = /\w+@[a-z]+.\w+/;

                    if (!re.test(email)) {

                        toastr.error("Formato do e-mail inválido");

                    } else {

                        const momentObj = moment(birthday, "DD/MM/YYYY");
                        const birthdayDate = momentObj.format("YYYY-MM-DD");

                        const user = {
                            Nome: name,
                            Email: email,
                            Senha: password,
                            Telefone: phone,
                            Cidade: city,
                            Data_nasc: birthdayDate,
                            Empresa: company,
                            Colegio: school,
                            Fl_receber_email: receiveMail,
                            Id_perfil: 2
                        }

                        const response = await API.User.Post(user);

                        if (response.data.emailEmUso) {

                            toastr.error("E-mail já cadastrado. Por favor, insira outro e-mail.");

                        } else {

                            //auth
                            const { data } = await API.Auth.Post({ email, senha: password })

                            if (data && data.sucessoNoLogin && data.token) {
                                localStorage.setItem("AuthorizationPl", data.token)

                                onUpdateUserData({ usuario: response.data.usuario });
                                window.location.href = "#/choose-school"
                                toastr.success("Cadastrado realizado.");
                            }else{
                                toastr.error("Bad server Response.");
                            }
                        }

                    }

                }

            }

        } catch (error) {

            toastr.error("Unable to register user: " + error, "Error!");
            console.error(error);

        } finally {

            setLoading(false);

        }

    }

    return (
        <Col md={12} className="form-login -large">
            {isLoading && <Loader />}
            <div>
                <div className="top">
                    <a href="#/login">
                        <img src={iconBack} />
                    </a>
                </div>
                <h3 className="form-title">Tell us more about you!  </h3>
                <p className="form-txt">Por favor, preencha e submeta o formulário a seguir e um dos nossos representantes deverá entrar em contato com você!</p>
                <form onSubmit={handleRegister} >
                    <Container>
                        <Row>
                            <Col md={6} sm={12}>
                                <input
                                    id="name"
                                    name="name"
                                    type="text" //type="email"
                                    className="form-input"
                                    placeholder="Nome Completo"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    id="email"
                                    name="email"
                                    type="text"
                                    className="form-input"
                                    placeholder="E-mail"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12}>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    className="form-input"
                                    placeholder="Senha"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    id="confirm_password"
                                    name="confirm_password"
                                    type="password"
                                    className="form-input"
                                    placeholder="Confirme a Senha"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12}>
                                <InputMask
                                    mask="(99)99999-9999"
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    className="form-input"
                                    placeholder="Telefone"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    id="city"
                                    name="city"
                                    type="text"
                                    className="form-input"
                                    placeholder="Cidade"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12}>
                                <InputMask
                                    mask="99/99/9999"
                                    id="birthday"
                                    name="birthday"
                                    type="text"
                                    className="form-input"
                                    placeholder="Data de Nascimento"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    id="company"
                                    name="company"
                                    type="text"
                                    className="form-input"
                                    placeholder="Empresa (Opcional)"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} sm={12}>
                                <input
                                    id="school"
                                    name="school"
                                    type="text"
                                    className="form-input"
                                    placeholder="Colégio (Opcional)"
                                    onChange={handleInput}
                                    autoComplete="on"
                                />
                            </Col>
                            <Col md={6} sm={12}>
                                <input
                                    type="submit"
                                    className="form-btn btn"
                                    value="Cadastrar"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="mt-3">
                                <div className="form-check">
                                    <input
                                        id="receiveMail"
                                        name="receiveMail"
                                        type="checkbox"
                                        className="form-check-input"
                                        onClick={(e: any) => setReceiveMail(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="receiveMail">
                                        Desejo receber uma análise detalhada do meu resultado pela escola
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </form>
            </div>
        </Col>
    )

}

export default Formulario;